import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CalculatorIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M3 2V20C3 21.6543 4.3457 23 6 23H18C19.6543 23 21 21.6543 21 20V2H3ZM19 20C19 20.5518 18.5518 21 18 21H6C5.44824 21 5 20.5518 5 20V4H19V20ZM17 9H7V6H17V9ZM9 14H7V12H9V14ZM11 12H13V14H11V12ZM15 12H17V14H15V12ZM9 18H7V16H9V18ZM11 16H13V18H11V16ZM15 16H17V18H15V16Z",
    fill: "currentColor"
  }));
}